// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150445/js/" + chunkId + "." + {"44":"4eef99c3","225":"46fb9a41","481":"5ccd0b16","486":"c46ae73b","770":"e379ecf1"}[chunkId] + ".0.3474145271831056.chunk.js";
};